import { render, staticRenderFns } from "./SettsPrivacy.vue?vue&type=template&id=fd51ecc2&scoped=true"
import script from "./SettsPrivacy.vue?vue&type=script&lang=js"
export * from "./SettsPrivacy.vue?vue&type=script&lang=js"
import style0 from "./SettsPrivacy.vue?vue&type=style&index=0&id=fd51ecc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd51ecc2",
  null
  
)

export default component.exports